export enum AdultsPickerModeEnum {
  DEFAULT = 'DEFAULT',
  HOUSE_SEARCH = 'HOUSE_SEARCH',
}
